import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild
} from '@angular/core';
import {
  ControlContainer,
  NgForm,
  NgModel
} from '@angular/forms';

import { TextControlComponent } from '../text-control/text-control.component';

@Component({
  selector   : 'wor-unique-text-control',
  template: require('./unique-text-control.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class UniqueTextControlComponent extends TextControlComponent implements AfterViewInit, OnDestroy {
  public isUnique = true;

  private _checkId       = 0;
  private _debounceTimer : number = null;

  @Input() checkInitially  = false;
  // Milliseconds to wait after the last keystroke before checking.
  @Input() debounce        = 0;
  // Replaces the whole label while the field is edited and duplicate.
  @Input() duplicateLabel ?: string;
  @Input() inputClass     ?: string;
  // Shows the duplicate warning from outside, e.g. when a linked field is the duplicate.
  @Input() isWarning       = false;
  @Input() validate        : ( value : string ) => Promise<boolean>;

  @Output() isUniqueChange : EventEmitter<boolean> = new EventEmitter();

  @ViewChild('input') ngModel : NgModel;

  get hasWarning () : boolean {
    return !this.isUnique || this.isWarning;
  }

  private _setUnique ( isUnique : boolean ) : void {
    if ( this.isUnique !== isUnique ) {
      this.isUnique = isUnique;
      this.isUniqueChange.emit(isUnique);
    }
  }

  ngAfterViewInit () : void {
    super.ngAfterViewInit();

    if (this.checkInitially && this._model && this.ngModel) {
      this.handleValidation();
    }
  }

  ngOnDestroy () : void {
    window.clearTimeout(this._debounceTimer);
  }

  handleModelChange ( _model : string ) : void {
    this.modelChange.emit(_model);

    window.clearTimeout(this._debounceTimer);

    this._checkId++;

    if ( this.debounce ) {
      this._debounceTimer = window.setTimeout(() => this.handleValidation(), this.debounce);
    }
    else {
      this.handleValidation();
    }
  }

  // Only the latest answer counts; a blank value or a failed check shows no warning.
  handleValidation ( _model = this._model ) : void {
    const checkId = ++this._checkId;

    if ( !_model ) {
      this._setUnique(true);

      return;
    }

    this.validate(_model)
    .then(( isUnique : boolean ) => {
      if ( checkId === this._checkId ) {
        this._setUnique(isUnique);
      }
    })
    .catch(() => {
      if ( checkId === this._checkId ) {
        this._setUnique(true);
      }
    });
  }

  showsDuplicateLabel ( input : NgModel ) : boolean {
    return !!this.duplicateLabel && this.hasWarning && !!input?.control.dirty;
  }
}
